import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { IndexDetail } from 'api'
import { DataGrid, GridId } from 'view/components/datagrid'
import { IndexColumnDefs, indexGridOptions } from './IndexGridModel'
import { indexDetailsSelector } from 'selectors/indexSelectors'

interface IndexGridProps {
  indexList: IndexDetail[]
}

const mapStateToProps = createStructuredSelector({
  indexList: indexDetailsSelector
})

export const IndexGridComponent: React.FC<IndexGridProps> = ({ indexList }) => {
  return (
    <DataGrid
      gridId={GridId.AdminIndexGrid}
      gridOptions={indexGridOptions}
      disableGrouping={true}
      rowData={indexList}
      columnDefs={IndexColumnDefs}
    />
  )
}

export const IndexGrid = connect(mapStateToProps)(IndexGridComponent)
